/**
 * @fileoverview GET handler for the "/engagement/content_blocks/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksTags } from "./constants";
import type { EngagementContentBlocksTagsResult } from "./types";

export const getEngagementContentBlocksTags = reactQueryFetcherAdapter(
  engagementContentBlocksTags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementContentBlocksTagsResult> => {
    return fetch(`/engagement/content_blocks/tags`, "GET", { app_group_id: appGroupId }, { signal });
  }
);
